import React, { Fragment, useRef, useState, useEffect } from 'react';
import Breadcrumb from '../common/breadcrumb';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import { toast } from 'react-toastify'; 
import Button from 'react-bootstrap-button-loader';
import axios from 'axios'
import ConfirmarUnidad from './confirmarProductos';

const Subida = () => {

    const [archivo_adjunto, setArchivo_adjunto] = useState([]);
    const [upload, setUpload] = useState(0);
    const [look, setLook] = useState(false);
    const [url, seturl] = useState(      /*  'http://localhost:3000'    */          'https://cms.lprefacciones.mx'      );

    const changeDropzone=({ meta, file }, status)=>{
		if(status === 'done'){
			console.log('done')
			getImage(file)
		}
		if(status === 'removed'){
			console.log('removed')
			setArchivo_adjunto([])
		}
		if(status=='error_file_size'){
            toast.warn(`El archivo debe ser inferior a 10 MB`,{ position: toast.POSITION.BOTTOM_RIGHT }); 
            setArchivo_adjunto([])
        }
        if(status=='rejected_file_type'){
            toast.warn(`El archivo debe ser con extension xlsx`,{ position: toast.POSITION.BOTTOM_RIGHT }); 
            setArchivo_adjunto([])
        }
	}

	const getImage = file =>{
        var reader = new FileReader();
        reader.onloadend = function () {
            var b64 = reader.result;
            setArchivo_adjunto([{name:file.name,base:b64}])
        };
        reader.readAsDataURL(file);
	}

    const subida=()=>{
        if(archivo_adjunto.length !=0){
            setLook(true)
            axios.request( {
                method: "POST", 
                url: "/p_excel", 
                data: {archivo_adjunto}, 
                onUploadProgress: (p) => setUpload(Math.floor((p.loaded / p.total)*100))
            })
            .then(response=>{
                fetch(url+'/productos_search', { method: 'POST', headers: {'Content-Type': 'application/json'}})
                setLook(false)
                setUpload(0)
                toast.success(`Archivo cargado con éxito`,{ position: toast.POSITION.BOTTOM_RIGHT });
            })
            .catch(error=>console.log(error))
        }
        else
            toast.warn(`Primero debe cargar el archivo`,{ position: toast.POSITION.BOTTOM_RIGHT });
    }
    
    return (
        <Fragment>
            <Breadcrumb parent="Inicio" title="Subir productos" />
            {
                <div className="container-fluid">
                    <div className="col-sm-12">
                        <div className="card p-4">
                            {
                                !look ?
                                <Fragment>
                                    <h5 className="font-weight-bold">Cargar Excel</h5>
                                    <Dropzone
					                	onChangeStatus={changeDropzone}
					                	maxFiles={1}
					                	maxSizeBytes={10485760}
					                	multiple={false}
					                	inputContent="Arrastre o toque para insertar un archivo" 
					                	inputWithFilesContent="Agregar archivo"
                                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
					                />

                                    <div className="col-md-12 mt-4">
                                        <div className="text-right">
                                            <Button className='btn-lg' onClick={subida} loading={look}>Subir</Button>
                                        </div>
                                    </div>
                                </Fragment>
                                :
                                <ConfirmarUnidad upload={upload}/>
                            }
                        </div>
                    </div>
                </div>
            }
        </Fragment>
    );
};

export default Subida;